(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["energy-cal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const inputs = {
    watt: document.getElementById('watt'),
    cost: document.getElementById('energycost'),
    hours: document.getElementById('hours'),
    bulbs: document.getElementById('use')
  };

  const outputs = {
    annualCurrentWatt: document.getElementById('annualcurrent'),
    annualCostCurrent: document.getElementById('yearlynormallamp'),
    savingWatt: document.getElementById('watts-energy-saving'),
    annualCostSaving: document.getElementById('yearlyenergysaving'),
    annualSavings: document.getElementById('total'),
    lifeSavings: document.getElementById('lifeenergysaving')
  };

  const BULB_LIFE_HOURS = 8000;

  function number(val) {
    return parseFloat(val) || 0;
  }

  function calculate() {
    const watt = number(inputs.watt.value);
    const costPerUnit = number(inputs.cost.value) / 100; // pence → pounds
    const hoursPerDay = number(inputs.hours.value);
    const bulbs = number(inputs.bulbs.value);

    // Energy saver = 20% wattage (Magento rule)
    const savingWatt = watt * 0.2;

    // Annual usage (kWh)
    const annualKwhCurrent =
      (watt / 1000) * hoursPerDay * 365 * bulbs;

    const annualKwhSaving =
      (savingWatt / 1000) * hoursPerDay * 365 * bulbs;

    const annualCostCurrent = annualKwhCurrent * costPerUnit;
    const annualCostSaving = annualKwhSaving * costPerUnit;

    const annualSavings =
      annualCostCurrent - annualCostSaving;

    // Lifetime savings
    const hoursPerYear = hoursPerDay * 365;
    const lifetimeYears =
      hoursPerYear > 0 ? BULB_LIFE_HOURS / hoursPerYear : 0;

    const lifeSavings =
      annualSavings * lifetimeYears;

    // Update UI (Magento-style direct DOM updates)
    outputs.annualCurrentWatt.textContent = watt.toFixed(0);
    outputs.annualCostCurrent.textContent = annualCostCurrent.toFixed(2);
    outputs.savingWatt.textContent = savingWatt.toFixed(0);
    outputs.annualCostSaving.textContent = annualCostSaving.toFixed(2);
    outputs.annualSavings.textContent = annualSavings.toFixed(2);
    outputs.lifeSavings.textContent = lifeSavings.toFixed(2);
  }

  // Auto-update on ANY input change
  Object.values(inputs).forEach(input => {
    input.addEventListener('input', calculate);
  });

  // Initial run
  calculate();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

  // Grid/List view toggle
  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.js-product-grid');
    const buttons = document.querySelectorAll('.view-toggle-btn');

    if (grid && buttons.length) {
      const savedView = localStorage.getItem('collectionView');

      if (savedView === 'list') {
        grid.classList.add('is-list-view');
        buttons.forEach(btn =>
          btn.classList.toggle('is-active', btn.dataset.view === 'list')
        );
      }

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const view = button.dataset.view;
          grid.classList.toggle('is-list-view', view === 'list');
          buttons.forEach(btn => btn.classList.remove('is-active'));
          button.classList.add('is-active');
          localStorage.setItem('collectionView', view);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
